import { render, staticRenderFns } from "./StudentPartnerSignupView.vue?vue&type=template&id=79c13e8c&scoped=true&"
import script from "./StudentPartnerSignupView.vue?vue&type=script&lang=js&"
export * from "./StudentPartnerSignupView.vue?vue&type=script&lang=js&"
import style0 from "./StudentPartnerSignupView.vue?vue&type=style&index=0&id=79c13e8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c13e8c",
  null
  
)

export default component.exports